import Cookies from "js-cookie";
import { Navigate, Outlet } from "react-router-dom";
import TrackPageView from "../../TrackPages";

const SignupProtection = () =>{
    const admin_id = Cookies.get("admin_id");
    const instructor_id = Cookies.get("instructor_id");
    const token = Cookies.get("token");;
    return(
        
        (admin_id || instructor_id) && token?
                <Navigate to='/'/>
                :
                <>
                <TrackPageView />
                <Outlet/>
                </>

    )
};
export default SignupProtection;